export function gabungRacikanKeItems<T extends { items?: unknown[] }>(
  resep: T
): T {
  if (!resep || !Object.hasOwnProperty.call(resep, "resep_racikan")) {
    return resep;
  }

  // @ts-ignore
  const { resep_racikan, ...sisa } = resep;

  return {
    ...sisa,
    items: [...(sisa.items || []), ...(resep_racikan || [])]
  } as T;
}
